import React, { useEffect, useState, useCallback } from "react";
import BasicModal from "../../Components/Modals/BasicModal";
import $ from 'jquery';
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import swal from 'sweetalert';
import axios from "axios";
import "../../assets/css/pages/profit-margins.css";
import noImage from "../../assets/media/svg/no-image.svg";
import AddProfitMargin from "./AddProfitMargin";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    $('#profit-margins thead tr')
      .clone(true)
      .addClass('filters display-none')
      .appendTo('#profit-margins thead');

    let table = $('#profit-margins').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "profit-margins-datatable",
        method: 'GET',
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      initComplete: function () {
        var api = this.api();

        // For each column
        api
          .columns()
          .eq(0)
          .each(function (colIdx) {
            // Set the header cell to contain the input element
            var cell = $('.filters th').eq(
              $(api.column(colIdx).header()).index()
            );
            var title = $(cell).text();
            $(cell).html('<input type="text" placeholder="' + title + '" />');

            // On every keypress in this input
            $(
              'input',
              $('.filters th').eq($(api.column(colIdx).header()).index())
            )
              .off('keyup change')
              .on('keyup change', function (e) {
                e.stopPropagation();

                // Get the search value
                $(this).attr('title', $(this).val());
                var regexr = '({search})'; //$(this).parents('th').find('select').val();

                var cursorPosition = this.selectionStart;
                // Search the column for that value
                api
                  .column(colIdx)
                  .search(
                    this.value != ''
                      ? regexr.replace('{search}', '(((' + this.value + ')))')
                      : '',
                    this.value != '',
                    this.value == ''
                  )
                  .draw(false);

                $(this)
                  .focus()[0]
                  .setSelectionRange(cursorPosition, cursorPosition);
              });
          });
      },
      "columns": [
        { data: 'id', name: 'id' },
        { data: 'name', name: 'name' },
        { data: 'category', name: 'category' },
        {
          data: 'commission_rate',
          render: function (data, type, row) {
            return row?.commission_rate + "<span class='fw-light'>%</span>";
          },
        },
        { data: 'consignment_days', name: 'consignment_days' },
        {
          data: 'actions',
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "columnDefs": [{
        "targets": [5],
        "orderable": false
      }],
      "order": [[0, "desc"]],
    });

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteProfitMargin(id, name, table, $(this));
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/profit-margins/' + id + '/edit');
    });

    $(`<span class='table-filter-icon' title='Filter'>
        <i class='fa fa-filter fs-4 br-1000'></i>Filter
        </span>`).insertAfter("#profit-margins_length label");
    $(".table-filter-icon").click(function () {
      $("#profit-margins thead .filters").toggle();

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

  }, []);

  const AddProfitMargin = () => {
    navigate('/profit-margins/create');
  }
  const deleteProfitMargin = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete profit margin "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('profitMargins/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          if (res.status == 200) {
            swal('The profit margin "' + name + '" has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  return (
    <>
      <div>
        <div className="d-flex flex-stack mb-5">
          {true && //Show If user is SuperAdmin
            <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
              <button type="button"
                className="btn btn-primary"
                data-bs-toggle="tooltip"
                title="Coming Soon"
                onClick={AddProfitMargin}
              >
                Add Profit Margin
              </button>
            </div>
          }
        </div>
        <table id="profit-margins" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
            <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th>ID</th>
              <th>Name</th>
              <th>Category</th>
              <th>Commission Rate</th>
              <th>Consignment Days</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}